import { useState } from 'react'
import { AccountRecord, useUpdateAutoHideAdCommentsMutation } from '../../api/client'
import DescriptiveToggle from './DescriptiveToggle'

const AutoHideAdCommentsToggle = ({ account }: { account: AccountRecord }) => {
    const [updateAutoHideAdComments, { loading }] = useUpdateAutoHideAdCommentsMutation()

    const [enabled, setEnabled] = useState(account.autoHideAllAdComments)

    const onToggle = async (isEnabled: boolean) => {
        setEnabled(isEnabled)

        await updateAutoHideAdComments({
            variables: {
                accountId: account.id,
                autoHideAdComments: isEnabled
            }
        })
    }

    return (
        <DescriptiveToggle
            id={`auto-hide-ad-comments-enabled-${account.id.toString()}`}
            disabled={false}
            checked={enabled ? enabled : false}
            label="Autohide ad comments"
            loading={loading}
            onToggle={onToggle}
            subtitle="Enable or disable blanket hiding ad comments"
            tooltip={''}
        />
    )
}

export default AutoHideAdCommentsToggle
